import React from 'react'
import { Table } from 'antd'
import styled from 'styled-components'
import { moneyInline } from '../../modules/Utils'

const StyledTable = styled(Table)`
  margin: 8px;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
`
export const StyledStrong = styled.strong`
  font-size: 16px;
  margin: 8px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.8) 80%, #1890ff 99%);
`

function Amount(props) {
  const { title, currency, data } = props
  return (
    <StyledTable
      columns={[
        {
          title: 'Name',
          dataIndex: 'name',
          render: (value) => <strong>{value}</strong>,
        },
        {
          title: 'Amount',
          dataIndex: 'amount',
          render: (value) => moneyInline(value, currency),
        },
      ]}
      dataSource={data}
      {...{
        bordered: false,
        loading: false,
        pagination: false,
        size: 'small',
        title: title && (() => <StyledStrong>{title}</StyledStrong>),
        showHeader: false,
        footer: false,
        scroll: undefined,
        hasData: true,
      }}
    />
  )
}

Amount.defaultProps = {
  data: [],
}

export default Amount
